import { z } from "zod";

import {
  PatchVariationDtoSchema,
  VariationDtoSchema,
} from "../../../dtos/variations";

export const PatchVariationRequestPathParamSchema = z.object({
  variationId: z.string().uuid(),
});

export type PatchVariationRequestPathParamType = z.infer<
  typeof PatchVariationRequestPathParamSchema
>;

export const PatchVariationRequestBodySchema = z.object({
  variation: PatchVariationDtoSchema,
});

export type PatchVariationRequestBodyType = z.infer<
  typeof PatchVariationRequestBodySchema
>;

export const PatchVariationResponseBodySchema = z.object({
  variation: VariationDtoSchema,
});

export type PatchVariationResponseBodyType = z.infer<
  typeof PatchVariationResponseBodySchema
>;
